module.exports = __webpack_public_path__ + "img/portfolio.ed75fc68.jpg";